/*
 * $Id:: index.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import NoImage from '../NoImage';

const useStyles = makeStyles((_theme) => ({
    appImage: {
        width: 'inherit',
        height: 'inherit',
        objectFit: 'cover',
    },
}));

const ApplicationImage = ({ image }) => {
    const classes = useStyles();

    const base64ToJpeg = 'data:image/jpeg;base64,'.concat(image);
    const [error, setError] = useState(false);
    return (
        <React.Fragment>
            {!!error ? <NoImage /> : <img src={base64ToJpeg} onError={() => setError(true)} className={classes.appImage} alt={'appication'} />}
        </React.Fragment>
    );
};

export default ApplicationImage;
